export const NEW_BY_PATIENT = "NEW_BY_PATIENT";
export const NEW_BY_PRACTITIONER = 'NEW_BY_PRACTITIONER';
export const CANCELLED_BY_PATIENT = "CANCELLED_BY_PATIENT";
export const CANCELLED_BY_PRACTITIONER = "CANCELLED_BY_PRACTITIONER";
export const CONFIRMED = "CONFIRMED";
export const TERMINATED = "TERMINATED";
export const CLOSED = "CLOSED";
export const cumulativeList = [NEW_BY_PATIENT, CONFIRMED, CLOSED];

export function listInModal() {
    return [
        { value: NEW_BY_PATIENT, label: 'Rdv demandé par le patient', color:'#FF4500' },
        { value: CANCELLED_BY_PATIENT, label: 'Annulé par le patient', color:'red' },
        { value: CANCELLED_BY_PRACTITIONER, label: 'Annulé par le praticien', color:'#FFA500' },
        { value: CONFIRMED, label: 'Accepté par le praticien', color:'#32CD32' },
    ];
}

export function list() {
    const displayStatus = [
        { value: TERMINATED, label: 'Terminé en attente des fichiers', color:'#0ffff8' },
        { value: CLOSED, label: 'Cloturé', color:'#00008B' },
    ]

    return listInModal().concat(displayStatus);
}


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/SelectList/Status.js